import React from "react";
import PropTypes from 'prop-types';
import { FormGroup, Card, Row, Col, FormText } from "reactstrap";
import styles from "components/styles.module.scss";
import { convertToBase64 } from "utills/index.js";
import { BEHAVIOUR } from 'helpers/constants';
import { getLocalizedText } from 'helpers/language';

const FileUploadComponent = (props) => {
  const { data, index, isResponseWrong, errors, language } = props;
  const answer = data.answer;

  const handleFileUpload = async (e) => {
    data.setSelectedOption({
      ...(answer?.[0] || {}),
      ext: e.target.files[0]?.name ?? '',
      value: await convertToBase64(e.target.files[0]),
    });
  };

  return (
    <Card
      className={
        isResponseWrong
          ? `${styles["highlight-div"]} ${styles["card-ui"]} m-3 p-3`
          : `${styles["card-ui"]} m-3 p-3`
      }
    >
      <Row>
        <Col md={11} className={`${styles["custom-col"]} ps-1`}>
          <span>
            <span>
              {data?.behaviour === BEHAVIOUR.MANDATORY ? "*" : null}
            </span>
            {index + 1}.
          </span>
          <div
            className={
              data.behaviour === BEHAVIOUR.MANDATORY
                ? `${styles["questions-ui"]} pe-0 ps-2`
                : "ps-2"
            }
            dangerouslySetInnerHTML={{
              __html: getLocalizedText(language, data.question, data.sp_question),
            }}
          ></div>
        </Col>
      </Row>
      <div className={`${styles["options-margin"]} mt-2 custom-input-label`}>
        <FormGroup>
          <input
            type="file"
            name="file"
            style={{ cursor: `pointer` }}
            accept="image/*,.pdf,.csv,.exl,.xlsx"
            onChange={handleFileUpload}
          />
        </FormGroup>
        <div>
          <FormText className={styles["error-text"]} color="danger">
            {errors}
          </FormText>
        </div>
      </div>
    </Card>
  );
};

FileUploadComponent.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isResponseWrong: PropTypes.bool,
  errors: PropTypes.string,
  language: PropTypes.string,
};

export default FileUploadComponent;
